<template>
  <div class="autocomplete" v-click-outside="onClickOutside">
    <v-input
      ref="autocompleteInput"
      :placeholder="placeholder"
      v-model="computedValue"
      @focus="open()"
      @keydown:down="down"
      @keydown:up="up"
      @keydown:enter="setValue(filteredItemIndex)"
      @iconClick="onIconClick()"
      icon-position="right"
      :autocomplete="isChrome ? 'chrome-off' : 'off'"
      class="autocomplete__input"
      :icon="value && !show && !notEmpty ? 'icon-close' : 'icon-show'"
      :label="label"
      :iconType="value && !show ? 'button' : 'icon'"
      :class="show ? 'autocomplete__input--active' : null"
      :error="error"
      v-scroll-into-view
      :disabled="disabled"
    />

<!--    <div class="autocomplete__dropdown" v-show="filteredItems.length > 0 && show" :style="{ maxWidth: `${inputWidth}px`, left: `${activatorOffsetLeft}px` }">-->
    <div class="autocomplete__dropdown" :class="position ? 'autocomplete__dropdown' + '--' + position : null" v-show="filteredItems.length > 0 && show" :style="{ maxWidth: `${inputWidth}px`, left: position === 'fixed' ? `${activatorOffsetLeft}px` : 'unset' }">
      <ul class="autocomplete__list" v-if="customSlot">
        <li
          v-for="(item, index) in filteredItems"
          :key="index"
          :class="`${toggleActiveClass(index)} ${listClass}`"
          @click="setValue(index)"
          @keyup.enter="up()"
          @keyup.up="up()"
          @keydown.down="down()">

          <!--
            @slot Use it for creating a custome list-element view
            @binding {object} of single item
          -->
          <slot name="item" :item="item"></slot>

        </li>
      </ul>
      <ul class="autocomplete__list" v-else>
        <li
          v-for="(item, index) in filteredItems"
          :key="index"
          :class="`${toggleActiveClass(index)} ${listClass}`"
          @click="setValue(index)"
          @keyup.enter="up()"
          @keyup.up="up()"
          @keydown.down="down()">

          <div class="autocomplete__list-item-content" >{{ itemText ? item[itemText] : item }} </div>

        </li>
      </ul>
    </div>
    <v-modal
      v-model="showModal"
      full
      animation="slide-up"
      unclosable
      no-padding
      no-background
      no-header-padding
    >

      <template v-slot:header>
        <modal-header-input @click="close()" :height="headerHeight" v-model="searchValue" autofocus v-scroll-into-view></modal-header-input>
      </template>

      <ul class="autocomplete__list" v-if="customSlot">
        <li
          v-for="(item, index) in filteredItems"
          :key="index"
          @click="setValue(index)"
          :class="`${toggleActiveClass(index)} ${listClass}`"
          @keyup.enter="up()"
          @keyup.up="up()"
          @keydown.down="down()">

          <!--
            @slot Use it for creating a custom list-element view
            @binding {object} of single item
          -->
          <slot name="item" :item="item"></slot>

        </li>
      </ul>
      <ul class="autocomplete__list py-1" v-else>
        <li
          v-for="(item, index) in filteredItems"
          :key="index"
          :class="`${toggleActiveClass(index)} ${listClass}`"
          @click="setValue(index)"
          @keyup.enter="up()"
          @keyup.up="up()"
          @keydown.down="down()"
          class="autocomplete__list-item">

          <div class="autocomplete__list-item-content px-2" >{{ itemText ? item[itemText] : item }} </div>

        </li>
      </ul>
    </v-modal>
  </div>
</template>

<script>
import vInput from '@/ui/controls/vInput'

import ModalHeaderInput from '@/ui/modals/ModalHeaderInput'
import vModal from '@/ui/modals/vModal'

import scrollIntoView from '@/directives/scrollIntoView'

import screen from '@/mixins/screen'

import ClickOutside from '../../../directives/clickOutside'

function getInitialACHeaderHeight () {
  return 65 + parseInt(getComputedStyle(document.documentElement).getPropertyValue('--sat'))
}

/**
 * @displayName Autocomplete
 */

export default {
  name: 'v-autocomplete',
  directives: {
    ClickOutside,
    scrollIntoView
  },

  data () {
    return {
      localValue: '',
      searchValue: '',
      // selectedItemIndex: 0,
      filteredItemIndex: this.autoSelect ? 0 : null,
      show: false,
      changed: 0,

      showModal: false,
      headerHeight: getInitialACHeaderHeight(),
      inputWidth: 300,
      activatorOffsetLeft: 0,
      activatorOffsetTop: 0
    }
  },

  mixins: [screen],

  props: {
    placeholder: {
      type: String,
      default: 'Start typing...'
    },

    /**
     * @model
     */
    value: {
      type: [String, Number, Object],
      default: null
    },

    valueField: {
      type: String,
      default: null
    },

    label: {
      type: String,
      default: null
    },

    /**
     * You may specify "async" type for making requests to server
     * @values sync, async
     */

    type: {
      type: String,
      default: 'sync'
    },
    /**
     * Specify if you are going to use a custom slot
     * @values true, false
     */

    customSlot: {
      type: Boolean,
      default: false
    },
    /**
     * An array of items for filtering
     * @values [String], [{Object}]
     */
    items: {
      type: Array,
      default: () => []
    },
    /**
     * A field name with text if you use objects for items
     */
    itemText: {
      type: String,
      default: null
    },

    /**
     * Always select the first option
     */
    autoSelect: {
      type: Boolean,
      default: false
    },
    /**
     * Changes class name of a selected option
     */
    activeClass: {
      type: String,
      default: 'autocomplete__list-item--active'
    },
    /**
     * Changes class name of list-items <li>
     */
    listClass: {
      type: String,
      default: 'autocomplete__list-item'
    },
    /**
     * @values icon, button
     */
    iconType: {
      type: String,
      default: 'icon'
    },
    emitObject: {
      type: Boolean,
      default: false
    },
    error: {
      type: String,
      default: null
    },
    notEmpty: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    position: {
      type: String,
      default: 'absolute'
    }
  },
  components: {
    vInput,
    vModal,
    ModalHeaderInput
  },
  computed: {
    isChrome () {
      return window.chrome && true
    },

    computedValue: {
      get () {
        if (this.show) {
          return this.searchValue
        }

        return this.localValue
      },
      set (val) {
        this.searchValue = val
      }
    },
    filteredItems () {
      const searchValue = this.searchValue.toString()
      if (searchValue > 0) {
        return this.items.filter(item => {
          const str = this.itemText ? item[this.itemText] : item.toString()

          return str.toLowerCase().match(searchValue.toLowerCase())
        })
      }

      return this.items
    }
  },
  methods: {
    onIconClick () {
      if (!this.notEmpty) {
        this.localValue = null
        this.$emit('input', null)
      } else if (!this.show) {
        setTimeout(() => {
          this.open()
        }, 100)
      } else if (this.show) {
        setTimeout(() => {
          this.close()
        }, 100)
      }
    },

    setValue (indexValue) {
      if (this.filteredItems.length > 0 && indexValue !== null) {
        const str = this.itemText ? this.filteredItems[indexValue][this.itemText] : this.filteredItems[indexValue]
        if (this.emitObject) {
          /**
           * Triggers when any of the options is selected. If you specify an array of objects in items and itemText it sends an object
           * @property {String}
           * @property {Object}
           */
          this.$emit('input', this.filteredItems[indexValue])
        } else {
          /**
           * Triggers when any of the options is selected. If you specify an array of objects in items and itemText it sends an object
           * @property {String}
           * @property {Object}
           */
          this.$emit('input', this.valueField ? this.filteredItems[indexValue][this.valueField] : this.filteredItems[indexValue])
        }
        this.localValue = str
        this.filteredItemIndex = 0
      }

      if (indexValue === null) {
      /**
       * Sends an input value if no options was selected.
       * It would be necessary for example, if you need to differently handle an action when the user entered a value but did not select any of the options
       * @property {String}
       */
        this.$emit('enter', this.localValue)
      }

      if (!this.autoSelect) {
        this.filteredItemIndex = null
      }

      this.changed++
      this.close()
    },
    close () {
      this.show = false
      this.showModal = false
    },
    open () {
      this.searchValue = ''
      if (this.screen.breakPoint.tabPort) {
        this.show = true
        document.addEventListener('keydown', this.closeOnEsc)
      } else {
        this.showModal = true
      }
    },
    closeOnEsc (event) {
      if (event.keyCode === 27) {
        this.close()
      }
    },
    onClickOutside () {
      if (this.screen.breakPoint.tabPort) {
        this.close()
      }
    },
    toggleActiveClass (currIndex) {
      if (currIndex === this.filteredItemIndex) return this.activeClass

      return ''
    },
    down () {
      if (this.filteredItemIndex === null) {
        this.filteredItemIndex = 0
      } else if (this.filteredItemIndex < this.filteredItems.length - 1) {
        this.filteredItemIndex++
      }

      this.open()
    },
    up () {
      if (this.filteredItemIndex > 0) {
        this.filteredItemIndex--
      } else {
        this.filteredItemIndex = null
      }
    },
    setInitialValue (newVal) {
      if (this.emitObject && newVal) {
        newVal = newVal[this.valueField]
      }

      if (this.valueField && this.itemText && this.items.length > 0) {
        const matched = this.items.find(item => {
          if (item[this.valueField] === null || newVal === null) {
            return item[this.valueField] === newVal
          }
          return item[this.valueField].toString() === newVal.toString()
        })

        if (matched) {
          this.localValue = matched[this.itemText]
        }
      } else if (!this.valueField && !this.itemText) {
        this.localValue = newVal
      }
    },

    computeHeights () {
      // const header = document.querySelector('.modal-header-input')
      // if (header) {
      //   this.headerHeight = header.clientHeight + parseInt(getComputedStyle(document.documentElement).getPropertyValue('--sat'))
      // }
      //
      // console.log(parseInt(getComputedStyle(document.documentElement).getPropertyValue('--sat')))
    },

    computeWidths () {
      const inputEl = this.$el

      if (inputEl) {
        this.inputWidth = inputEl.clientWidth
      }
    },

    computeOffset () {
      const elem = this.$el
      if (!elem) {
        return
      }
      const box = elem.getBoundingClientRect()

      if (!elem) {
        return
      }
      this.activatorOffsetLeft = box.left + pageXOffset
      this.activatorOffsetTop = box.top + pageYOffset
    }
  },
  mounted () {
    this.setInitialValue(this.value)
  },
  watch: {
    items () {
      if (this.type !== 'async') {
        this.searchValue = ''
      }

      this.setInitialValue(this.value)
    },
    value (newVal) {
      this.setInitialValue(newVal)
    },
    show (newVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.computeWidths()
          this.computeOffset()
        })
      }
      /**
       * Events triggers when the dropdown shows or hides
       * @property {Boolean}
       */
      if (newVal === false) {
        document.removeEventListener('keydown', this.closeOnEsc)
      }
      this.$emit('show', newVal)
    },
    changed () {
      // This need to close dropdown just on change (setValue)
      this.close()
    },
    'screen.height' () {
      this.computeWidths()
      this.computeOffset()
    },
    'screen.width' () {
      this.computeWidths()
      this.computeOffset()
    }
  }
}
</script>

<style lang="scss">
  .autocomplete {
    position: relative;
    &__input {
      input {
        cursor: pointer;
      }

      &--active {
        input {
          cursor: initial;
        }
      }
    }

    &__dropdown {
      max-height: 30rem;
      overflow-y: auto;
      position: absolute;
      width: 100%;
      margin-top: -2px;
      border-radius: 0 0 3px 3px;
      border: 1px $color-grey-light solid;
      background-color: $color-white;
      box-shadow: $elevation;
      z-index: 99;

      &--fixed {
        position: fixed;
      }
    }

    &__list-item {
      cursor: pointer;
      display: block;
      color: $color-black;
      font-size: 1.4rem;
      font-weight: 400;

      &--active > * {
        background-color: darken($color-grey-lighten, 1%);
      }
    }

    &__list-item {
      /*<!--&:not(:last-child) {-->*/
      /*<!--  border-bottom: 1px $color-grey-lighten solid;-->*/
      /*<!--}-->*/
    }

    &__list-item-content {
      padding: 1.5rem 1rem;

      @media(hover: hover) and (pointer: fine) {
        &:hover {
          background-color: darken($color-grey-lighten, 1%);
        }
      }

      &:active {
        background-color: darken($color-grey-lighten, 1%);
      }
    }

    &__modal-header {
      width: 100%;
      height: 100%;
    }

    &__mobile-input {
      border: none;
      height: 100%;
      width: 100%;

      &:focus {
        border: none;
        outline: none;
      }
    }
  }
</style>
